import React from "react";
import { getInitialData } from "../service/apiFetch";
import Innerhtml from "../components/utils/Innerhtml";

export const getStaticProps = async () => {
  const initialData = await getInitialData("about-us", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      error: initialData?.error || "",
    },
  };
};

const SchoolWelcomePage = ({ data }) => {
  const ABOUTUS = data?.contentBlock?.ABOUTUS || {};
  const rawHistory = ABOUTUS?.advanceData?.data;
  const historyItems = Array.isArray(rawHistory) ? rawHistory : [];

  return (
    <div className="flex w-full flex-col bg-gray-100">
      <div className="container flex flex-col items-center justify-between py-16 md:flex-row">
        <div className="w-full pr-0 md:w-1/2 md:pr-4">
          <h1 className="mb-4 text-4xl font-bold sm:text-5xl">
            <span className="text-orange-500">{ABOUTUS.heading}</span>
          </h1>
          <p className="mb-8 text-gray-600">{ABOUTUS.subHeading}</p>
        </div>

        <div className="relative mt-10 w-full md:mt-0 md:w-1/2">
          <div className="relative mx-auto h-64 w-64 overflow-hidden md:h-80 md:w-80">
            <img
              src={ABOUTUS.link}
              alt="School"
              className="h-full w-full object-cover"
            />
          </div>

          <div className="absolute right-8 top-12 h-6 w-6 rounded-full bg-orange-400 sm:right-16" />
          <div className="absolute bottom-4 right-4 h-8 w-8 rounded-full bg-yellow-400 sm:right-8" />
          <div className="absolute bottom-2 left-10 h-4 w-20 rounded-full bg-blue-200 opacity-50 sm:left-16" />
        </div>
      </div>

      <div className="bg-white px-4 py-12 sm:px-8">
        <div className="mx-auto max-w-6xl">
          <h2 className="mb-8 text-center text-3xl font-bold">
            <Innerhtml data={ABOUTUS?.content} />
          </h2>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {historyItems.map((history, index) => (
              <div key={index} className="space-y-6">
                <div
                  className={`border-l-4 pl-4 ${
                    index % 2 === 0 ? "border-orange-500" : "border-blue-500"
                  }`}
                >
                  <h3 className="mb-2 text-xl font-semibold">{history.title}</h3>
                  <div className="text-gray-700">
                    <Innerhtml data={history.desci} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchoolWelcomePage;
